export default "__VITE_ASSET__6e1b4d75__"